export const saasCanvasSx = {
  background:
    'radial-gradient(circle at top left, rgba(95,111,255,0.10), transparent 18%), radial-gradient(circle at top right, rgba(106,196,255,0.12), transparent 20%), linear-gradient(180deg, #f3f6fb 0%, #edf2f7 54%, #e7edf6 100%)',
  flexGrow: 1,
  minHeight: '100vh',
  overflow: 'auto',
};

export const saasWorkspaceCardSx = {
  p: { xs: 2.25, md: 2.75 },
  borderRadius: 6,
  border: '1px solid #dbe3ef',
  background: 'linear-gradient(180deg, rgba(255,255,255,0.98) 0%, rgba(248,250,253,0.98) 100%)',
  boxShadow: '0 18px 40px rgba(31,45,72,0.07)',
};

export const saasMetricCardSx = {
  p: 2,
  borderRadius: 4,
  border: '1px solid #e3e8f2',
  background: 'linear-gradient(180deg, rgba(255,255,255,0.96) 0%, rgba(247,249,252,0.96) 100%)',
  boxShadow: '0 10px 24px rgba(31,45,72,0.04)',
};

export const saasToolbarCardSx = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  mb: 3,
  width: '100%',
  flexWrap: 'wrap',
  gap: 1.5,
  p: 2,
  borderRadius: 5,
  background: 'linear-gradient(180deg, rgba(255,255,255,0.98) 0%, rgba(247,249,252,0.96) 100%)',
  border: '1px solid #dbe3ef',
  boxShadow: '0 16px 34px rgba(31,45,72,0.06)',
};

export const saasActionRowSx = {
  ...saasToolbarCardSx,
  alignItems: 'stretch',
  gap: 2,
};

export const saasTabsSx = {
  minHeight: 0,
  '& .MuiTabs-flexContainer': {
    gap: 1,
    flexWrap: 'wrap',
  },
  '& .MuiTab-root': {
    minHeight: 46,
    borderRadius: 3,
    px: 2,
    textTransform: 'none',
    fontWeight: 700,
    color: '#667085',
  },
  '& .Mui-selected': {
    color: '#25324b',
    background: 'rgba(95,111,255,0.10)',
  },
  '& .MuiTabs-indicator': {
    height: 3,
    borderRadius: 999,
    backgroundColor: '#5f6fff',
  },
};

export const saasSectionCardSx = {
  p: { xs: 2.25, md: 2.75 },
  borderRadius: 6,
  border: '1px solid #dbe3ef',
  background: 'linear-gradient(180deg, rgba(255,255,255,0.98) 0%, rgba(248,250,253,0.98) 100%)',
  boxShadow: '0 18px 40px rgba(31,45,72,0.07)',
};

export const saasDirectoryWrapSx = {
  p: { xs: 2, md: 2.5 },
  borderRadius: 7,
  border: '1px solid #dbe3ef',
  background: 'linear-gradient(180deg, rgba(255,255,255,0.98) 0%, rgba(247,249,252,0.98) 100%)',
  boxShadow: '0 24px 48px rgba(31,45,72,0.07)',
};

export const saasDirectoryRowSx = {
  p: { xs: 1.75, md: 2.1 },
  borderRadius: 999,
  border: '1px solid #dbe3ef',
  background: 'linear-gradient(180deg, rgba(255,255,255,1) 0%, rgba(249,251,254,0.98) 100%)',
  boxShadow: '0 12px 26px rgba(31,45,72,0.05)',
  transition: 'transform 160ms ease, box-shadow 160ms ease, border-color 160ms ease',
  '&:hover': {
    transform: 'translateY(-1px)',
    boxShadow: '0 18px 32px rgba(31,45,72,0.08)',
    borderColor: '#c9d4e7',
  },
};

export const saasSoftCountSx = {
  minWidth: 92,
  minHeight: 56,
  borderRadius: 3,
  border: '1px solid #dfe6f4',
  background: 'linear-gradient(180deg, rgba(242,246,255,0.98) 0%, rgba(248,250,255,0.98) 100%)',
  display: 'grid',
  placeItems: 'center',
  textAlign: 'center',
  px: 1.5,
  boxShadow: '0 10px 20px rgba(95,111,255,0.08)',
};

export const saasCircleCountSx = {
  width: 74,
  height: 74,
  borderRadius: "50%",
  border: "1px solid #dfe6f4",
  display: "grid",
  placeItems: "center",
  bgcolor: "rgba(248,250,255,0.98)",
};

export const saasInputSx = {
  minWidth: 240,
  '& .MuiOutlinedInput-root': {
    minHeight: 46,
    background: 'rgba(255,255,255,0.92)',
    boxShadow: '0 10px 24px rgba(31,45,72,0.05)',
    borderRadius: '14px',
    '& fieldset': {
      borderWidth: '1px',
      borderColor: '#d8e0ec',
    },
    '&:hover fieldset': {
      borderWidth: '1px',
      borderColor: '#93a3ff',
    },
    '&.Mui-focused fieldset': {
      borderWidth: '1px',
      borderColor: '#5f6fff',
    },
  },
};

export const saasHeroActionButtonSx = {
  minWidth: 162,
  minHeight: 40,
  px: 2.1,
  borderRadius: "10px",
  fontSize: 14,
  fontWeight: 800,
  letterSpacing: "-0.01em",
  background: "linear-gradient(135deg, #5b67f6 0%, #6170ff 100%)",
  boxShadow: "0 10px 24px rgba(95,111,255,0.26)",
  "& .MuiButton-startIcon": {
    mr: 0.8,
    ml: -0.2,
  },
  "& .MuiSvgIcon-root": {
    fontSize: 18,
  },
  "&:hover": {
    background: "linear-gradient(135deg, #5360f0 0%, #5d6dff 100%)",
    boxShadow: "0 14px 28px rgba(95,111,255,0.32)",
  },
};
